import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";

import { StreakSection } from ".";
import { HeadToHead } from "../../pages/event/components/head-to-head/HeadToHead";
import { EventContentSkeleton } from "..";
import GoalDistribution from "../../pages/event/components/goal-distribution/GoalDistribution";
import { CompetitionAverages } from "../../pages/event/components/competition-averages/CompetitionAverages";

export const StreakStatsBody = observer(function StreakStatsBody(props: {
	store: EventViewStore | AdditionalOfferViewStore;
}) {
	const { t } = useTranslation();

	if (props.store.sportStatisticsStore.loader.isLoading) {
		return <EventContentSkeleton />;
	}

	if (!props.store.sportStatisticsStore.filteredStreakStats) {
		return null;
	}


	return (
		<div className="event__content">
            {props.store.sportStatisticsStore.filteredStreakStats.data
				.competitionAverages && (
				<CompetitionAverages
					title={t(`EVENT.STATISTICS.STREAK_STATS.TITLE_COMPETITION_AVERAGES`)}
					data={
						props.store.sportStatisticsStore.filteredStreakStats
							.data.competitionAverages
					}
					tournament={props.store.tournament}
					homeTeam={props.store.teamOne}
					awayTeam={props.store.teamTwo}
				/>
			)}
			{props.store.sportStatisticsStore.filteredStreakStats.data
				.headToHead && (
				<HeadToHead
					title={t(
						"EVENT.STATISTICS.STREAK_STATS.TITLE_HEAD_TO_HEAD"
					)}
					data={
						props.store.sportStatisticsStore.filteredStreakStats
							.data.headToHead
					}
					tournament={props.store.tournament}
					homeTeam={props.store.teamOne}
					awayTeam={props.store.teamTwo}
				/>
			)}
			{props.store.sportStatisticsStore.filteredStreakStats.data
				.general && (
				<StreakSection
					title={t("EVENT.STATISTICS.STREAK_STATS.TITLE_STREAKS")}
					data={
						props.store.sportStatisticsStore.filteredStreakStats
							.data.general
					}
					tournament={props.store.tournament}
					homeTeam={props.store.teamOne}
					awayTeam={props.store.teamTwo}
				/>
			)}
			{props.store.sportStatisticsStore.filteredStreakStats.data
				.goalDistribution && (
				<GoalDistribution
					title={t(`EVENT.STATISTICS.GOAL_DISTRIBUTION.TITLE`)}
					data={
						props.store.sportStatisticsStore.filteredStreakStats
							.data.goalDistribution
					}
					tournament={props.store.tournament}
					homeTeam={props.store.teamOne}
					awayTeam={props.store.teamTwo}
				/>
			)}
		</div>
	);
});
